import { render } from "./portcapabilities.vue?vue&type=template&id=25f47192"
import script from "./portcapabilities.vue?vue&type=script&lang=js"
export * from "./portcapabilities.vue?vue&type=script&lang=js"

import "./portcapabilities.vue?vue&type=style&index=0&id=25f47192&lang=scss"

import exportComponent from "C:\\laragon\\www\\juani\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__